import { version } from "../../package.json"

export const Version = (props) => {
  return (<>{version}</>)
}
